import React, {useState} from 'react';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Button, Divider, Layout, Text, Icon, Modal, Card } from '@ui-kitten/components';
import { StyleSheet, ScrollView, Image, Dimensions, View, Linking } from 'react-native';
import {LoginForm} from './login-form.js'
import {ConfirmForm} from './confirm-form.js'
import {useSelector, useDispatch} from 'react-redux';
import {saveInfo} from '../../../store/actions/login'
import trackerApi from '../../api/tracker';
import { showMessage, hideMessage } from "react-native-flash-message";
import * as Device from 'expo-device';
import Constants from "expo-constants"
import * as Application from 'expo-application';

// const version = Application.nativeBuildVersion
const version = Constants.expoConfig.version
import * as RootNavigation from '../../../root.navigation.js';
import AsyncStorage from '@react-native-async-storage/async-storage';
const AlertIcon = (props) => (
  <Icon {...props} name='alert-triangle' style={{width:16, height:16, marginHorizontal: 10}} fill='#ffffff'/>
);
const SuccessIcon = (props) => (
  <Icon {...props} name='checkmark-circle-2' style={{width:16, height:16, marginHorizontal: 10}} fill='#ffffff'/>
);
const LinkIcon = (props) => (
  <Icon {...props}  name='external-link-outline'/>
);
const CloudIcon = (props) => (
  <Icon {...props} name='cloud-download' style={{width:48, height:48, marginHorizontal: 10}} fill='#134A93'/>
);


const  width= Dimensions.get('window').width-40
const  height= Dimensions.get('window').height
export const LoginScreen = ({ navigation }) => {
  const phoneEntered = useSelector( state => state.login.phoneEntered);
  const [downloadURL, setDownloadURL] = useState('')
  const [visible, setVisible] = useState(false)
  const [splash, setSplash] = useState(true)
  const [nextVersion, setNextVersion] = useState('')

  const dispatch = useDispatch();
  const getLatestVersion = async()=>{
    const response = await trackerApi.post('/getLatestVersion', {});
    console.log(response.data.result.version);
    // if(true){
    //   if(response.data.status && version!== response.data.result.version){
    //   setNextVersion(response.data.result.version)
    //   setVisible(true)
    //   setDownloadURL(response.data.result.url)
    // }
    // else{
      const user = await AsyncStorage.getItem('userId');
      if(user) {
        const device = {
          deviceBrand: Device.brand,
          deviceName: Device.deviceName,
          modelName: Device.modelName,
          osName: Device.osName,
          osVersion: Device.osVersion
        }
        const response = await trackerApi.post('/checkInfo', {user, device});
        if(response.data.login){
          dispatch(saveInfo(response.data.user))
          showMessage({
            message: `وارد شدید`,
            type: "success",
            icon: SuccessIcon
          });
          RootNavigation.navigate('Menu')
        }
        else{
          setSplash(false)

          showMessage({
            message: response.data.error,
            type: "danger",
            icon: AlertIcon
          });
        }
      }
      else{
        setSplash(false)
      }
  //   }
  // }
}
  // const getData = async ()=>{
  //   const user = await AsyncStorage.getItem('userId');
  //   if(user) {
  //     const device = {
  //       deviceBrand: Device.brand,
  //       deviceName: Device.deviceName,
  //       modelName: Device.modelName,
  //       osName: Device.osName,
  //       osVersion: Device.osVersion
  //     }
  //     const response = await trackerApi.post('/checkInfo', {user, device});
  //     if(response.data.login){
  //       dispatch(saveInfo(response.data.user))
  //       showMessage({
  //         message: `وارد شدید`,
  //         type: "success",
  //         icon: SuccessIcon
  //       });
  //       RootNavigation.navigate('Menu')
  //     }
  //     else{
  //       showMessage({
  //         message: response.data.error,
  //         type: "danger",
  //         icon: AlertIcon
  //       });
  //     }
  //   }
  // }

  getLatestVersion();
  return (
      <Layout level='2' style={styles.container}>
      <SafeAreaView>
      { splash &&
        <Image
          style={{width, height}}
          source={require('../../../assets/splash2.png')}
        />
      }
      { !splash &&
      <ScrollView>
      <Layout level='2' style={{justifyContent:'space-between', alignItems:'center'}}>
        <Layout level='2' style={{alignItems:'center', marginTop:5}}>
          <Image
            style={{width:width*0.6, height: width*0.6/4.93}}
            source={require('../../../assets/logo.png')}
          />
          <Text category='h5' status='primary'>فناوران نوین پارسیان تصویر فدک</Text>
          <Text category='p1' appearance='hint' >نرم افزار خدمات پس از فروش</Text>
          <Text category='c2' appearance='hint' >مخصوص تکنسین‌های فنی</Text>
          <Image
            style={{width:width, height: width/1.73, marginVertical:20}}
            source={require('../../../assets/ill.png')}
          />
        </Layout>
        { !phoneEntered && <LoginForm /> }
        { phoneEntered && <ConfirmForm /> }
        <Layout level='2' style={{alignItems:'center', marginBottom:10}}>
          <Text category='c2' appearance='hint' >تمامی حقوق متعلق به شرکت فناوران نوین پارسیان تصویر فدک می‌باشد.</Text>
          <Text category='c2' appearance='hint' >ورژن: {Application.nativeBuildVersion /*Constants.manifest.version*/}</Text>
        </Layout>

      </Layout>
      </ScrollView>
    }
      <Modal
      visible={visible}
      backdropStyle={styles.backdrop}>
      <Card disabled={true} style={{ maxWidth: width*0.95}}>
      <View style={{justifyContent:'space-between', alignItems:'center'}}>
        <CloudIcon />
        <Text status='primary' category='h5'>بروز رسانی</Text>
        <Text appearance='hint' category='c2'>نسخه فعلی: {version}</Text>
        <Text appearance='hint' category='c2'>نصب نسخه: {nextVersion}</Text>
        <Text style={{marginTop:10, textAlign:'center'}}>لطفا جهت کار با برنامه، اپلیکیشن را از طریق لینک زیر آپدیت فرمایید.</Text>
        <View style={{flexDirection:'row' , justifyContent:'space-between', marginTop:25}}>

        <Button style={{width: 0.7*width}} accessoryLeft={LinkIcon} onPress={()=>{Linking.openURL(downloadURL)}}>
       دانلــود
        </Button>
        </View>
        </View>
      </Card>
    </Modal>
      </SafeAreaView>

      </Layout>
  );
};

const styles = StyleSheet.create({
  container:{
    flex:1,
    justifyContent:'space-around',
    alignItems:'center'
  },
  backdrop: {
    backgroundColor: 'rgba(4, 7, 32, 0.8)',
  },
});
